

export class Item<T> {
  constructor(
    public payload: T,
    public pos: number) {};

}


export class DictList<T> {

  protected _list: Item<T>[] = [];
  protected _dict: {[index: string]: Item<T>} = {};

  protected keyExists(key: string): boolean {
    return typeof this._dict[key] !== 'undefined';
  }

  protected posExists(pos: number): boolean {
    return typeof this._list[pos] !== 'undefined';
  }

  protected getItem(key: string): Item<T> {
    return this._dict[key];
  }

  protected getItemInPos(pos: number): Item<T> {
    return this._list[pos];
  }

  protected addItem(key: string, value: T) {
    let item = new Item<T>(value, this._list.length);
    this._dict[key] = item;
    this._list.push(item);
  }

  protected updateItem(key: string, value: T) {
    this._dict[key].payload = value;
  }

  public put(key: string, value: T) {
    if (this.keyExists(key)) {
      this.updateItem(key, value);
    }
    else {
      this.addItem(key, value);
    }
  }

  public get(key: string): T {
    let value: T;
    if (this.keyExists(key)) {
      value = this.getItem(key).payload;
    }
    return value;
  }

  public pos(pos: number): T {
    let value: T;

    if (this.posExists(pos)) {
      value = this.getItemInPos(pos).payload;
    }

    return value;
  }

  public list(): T[] {
    return this._list.map(item => item.payload);
  }

  public dict() {
    let dict: {[index: string]: T} = {};
    for (var key in this._dict) {
      dict[key] = this.getItem(key).payload;
    }
    return dict;
  }

  public remove(key: string) {
    let item = this.getItem(key);

    if (item) {
      this._list.splice(item.pos, 1);
      delete this._dict[key];
    }
  }

  public clear() {
    this._list = [];
    this._dict = {};
  }
}
